import React, { ElementType } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

interface Props {
    to: string;
    icon: ElementType;
    label: string;
    collapsed: boolean;
    onClick?: () => void;
}

const NavItem = ({ to, icon: Icon, label, collapsed, onClick }: Props) => {
    const location = useLocation();
    const active = location.pathname === to;

    return (
        <Link to={to} onClick={onClick} className="relative group block px-1">
            <motion.div
                whileHover={{ x: active ? 0 : 3 }}
                whileTap={{ scale: 0.98 }}
                className={`
                    flex items-center transition-all duration-300 relative
                    ${collapsed
                    ? 'justify-center h-8 w-8 mx-auto rounded-lg'
                    : 'gap-3 p-2.5 w-full rounded-xl'}
                    ${active
                    ? 'sidebar-nav-active text-blue-400 bg-blue-500/10'
                    : 'text-slate-500 hover:text-white hover:bg-white/5'}
                `}
            >
                {/* Indicador Neon Lateral (Apenas quando ativo) */}
                {active && (
                    <motion.div
                        layoutId="activeIndicator"
                        className="sidebar-active-indicator absolute left-0 w-1 h-4 bg-blue-500 rounded-r-full"
                    />
                )}

                <div className={`shrink-0 flex items-center justify-center transition-transform duration-300 ${active ? 'scale-110' : 'group-hover:scale-110'}`}>
                    <Icon
                        size={18}
                        strokeWidth={active ? 2.5 : 2}
                        className={active ? 'sidebar-active-icon' : ''}
                    />
                </div>

                {!collapsed && (
                    <span className={`text-sm font-bold truncate ${active ? 'text-white' : 'text-slate-400'}`}>
                        {label}
                    </span>
                )}
            </motion.div>

            {/* Tooltip Neon quando colapsado */}
            {collapsed && (
                <div className="sidebar-nav-tooltip absolute left-full ml-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 bg-[#0f172a] text-blue-400 text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-md border border-blue-500/30 whitespace-nowrap z-[100] pointer-events-none transition-all duration-200 translate-x-[-10px] group-hover:translate-x-0">
                    {label}
                </div>
            )}
        </Link>
    );
};

export default NavItem;
